import { Reveal } from "./Reveal";
import { useLang } from "../config/i18n";

export const AvisoLegal = () => {
  const { t } = useLang();

  return (
    <section id="aviso" data-testid="legal-notice-section" className="relative py-20 sm:py-24 bg-[#0D0D10] border-t border-[#22222B]">
      <div className="max-w-3xl mx-auto px-6">
        <Reveal>
          <p className="text-[11px] font-semibold tracking-[0.3em] text-[#C5A059] uppercase mb-5">{t.aviso.overline}</p>
          <h2 className="font-heading text-2xl sm:text-3xl text-[#F7F7F8] leading-snug mb-8">{t.aviso.title}</h2>
          <div className="space-y-4 text-sm sm:text-[15px] text-[#A3A3AF] leading-relaxed font-light">
            {t.aviso.paragraphs.map((p) => (
              <p key={p.slice(0, 24)}>{p}</p>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
